import { render } from "./notify-me.vue?vue&type=template&id=3bfdec92"
import script from "./notify-me.vue?vue&type=script&lang=js"
export * from "./notify-me.vue?vue&type=script&lang=js"

import "./notify-me.vue?vue&type=style&index=0&id=3bfdec92&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__